/* Tea Lab blog page: on phones the topic buttons scroll sideways, so this brings the chosen topic into view. */
(function () {
  function init(root) {
    (root || document).querySelectorAll('.tlb__chips').forEach(function (list) {
      var on = list.querySelector('.is-active');
      if (!on || list.scrollWidth <= list.clientWidth) return;
      list.scrollLeft = Math.max(0, on.offsetLeft - 20);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();